import { render, staticRenderFns } from "./PorGrupo.vue?vue&type=template&id=49efdbc1&lang=pug&"
import script from "./PorGrupo.vue?vue&type=script&lang=js&"
export * from "./PorGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports